import { useEffect, useState } from 'react';
import { ListTree } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

export const StickyToc = ({ items }) => {
  const [active, setActive] = useState(items[0]?.id);
  const { t } = useLang();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-25% 0px -65% 0px' }
    );
    items.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [items]);

  return (
    <aside data-testid="sticky-toc" className="hidden lg:block sticky top-28 self-start">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-muted-foreground mb-5">
        <ListTree className="h-4 w-4" />
        {t('tocTitle')}
      </p>
      <nav className="flex flex-col border-l border-border" aria-label="Indice dei contenuti">
        {items.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            data-testid={`toc-${item.id}`}
            className={`-ml-px border-l-2 pl-4 py-2 text-sm transition-colors duration-150 ${
              active === item.id ? 'border-primary text-primary font-semibold' : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            {item.label}
          </a>
        ))}
      </nav>
    </aside>
  );
};
